<div *ngIf="isVisible()" [id]="navLink.id" class="product-details-section">
  <div class="container-fluid ds-grid">
    <div class="row pt-7 mb-6">
      <h2 class="col d-flex justify-content-center ds-heading--l mb-0">{{navLink.headline | cxTranslate}}</h2>
    </div>
    <div class="row mb-sm-6">
      <div class="col-12">
        <div class="d-flex justify-content-start justify-content-sm-center resource-link-wrapper">
          <div class="d-flex flex-column flex-sm-row">
            <div class="d-flex flex-column flex-md-row">
              <div *ngIf="support && support.knowledgebase" class="resource-link">
                <a
                  [href]="support.knowledgebase"
                  class="btn btn-link udex-p-0 udex-m-0 d-flex flex-nowrap align-items-center"
                  data-cy="resource-support-page"
                  target="_blank"
                >
                  <img alt="open book image" class="me-3" src="../../../../assets/images/education_blue.svg">
                  {{'productDetails.supportPage' | cxTranslate}}
                </a>
              </div>
              <div *ngIf="support && support.email" class="resource-link">
                <a
                  [href]="'mailto:' + support.email"
                  class="btn btn-link udex-p-0 udex-m-0 d-flex flex-nowrap align-items-center"
                  data-cy="resource-contact-support"
                  target="_blank"
                >
                  <img alt="headset image" class="me-3" src="../../../../assets/images/headset_blue.svg">
                  {{'productDetails.contactSupport' | cxTranslate}}
                </a>
              </div>
            </div>
            <div class="d-flex flex-column flex-md-row">
              <div *ngIf="privacy" class="resource-link">
                <a
                  [href]="privacy"
                  class="btn btn-link udex-p-0 udex-m-0 d-flex flex-nowrap align-items-center"
                  data-cy="resource-privacy-statement"
                  target="_blank"
                >
                  <img alt="security shield" class="me-3" src="../../../../assets/images/badge_blue.svg">
                  {{'productDetails.privacyStatement' | cxTranslate}}
                </a>
              </div>
              <div class="resource-link">
                <ng-container *ngIf="terms; else termsConditionsPopup">
                  <a [href]="terms"
                     (click)="triggerEddlDownloadAttemptEvent($event); triggerEddlDownloadSuccessEvent($event)"
                     class="btn btn-link udex-p-0 udex-m-0 d-flex flex-nowrap align-items-center"
                     data-cy="resource-terms-and-conditions"
                     target="_blank"
                  >
                    <img alt="legal paper" class="me-3" src="../../../../assets/images/newspaper_blue.svg">
                    {{'productDetails.termsAndConditions' | cxTranslate}}
                  </a>
                </ng-container>
                <ng-template #termsConditionsPopup>
                  <dcp-terms-conditions [entry]="termsConditionsProductEntries[0]"
                                        [entries]="termsConditionsProductEntries"
                                        [isStoreHeaderShown]="true"
                                        [pdpTerms]="{isPdpTerms: true, showIconLink: true}">
                  </dcp-terms-conditions>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 separator d-none d-sm-block"></div>
  </div>
  <div *ngIf="resources.length > 1" class="ds-grid container-fluid d-none d-lg-block">
    <div [class.justify-content-center]="resources.length < entryLimit" class="row desktop-row">
      <div *ngFor="let resource of limitedResources"
           class="col-3 flex-column desktop-tile"
      >
        <dcp-product-resource-tile [resource]="resource"></dcp-product-resource-tile>
      </div>
    </div>
    <div *ngIf="resources.length > entryLimit" class="row">
      <div class="col d-flex justify-content-center">
        <div (click)="toggleResources()" (keydown)="toggleResourcesWithKeyboard($event)" class="btn btn-outline-primary"
             tabindex="0">
          {{(resourcesExtended ? 'productDetails.lessResources' : 'productDetails.moreResources') | cxTranslate}}
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="resources.length == 1" class="d-none d-lg-block">
    <dcp-product-single-resource-tile
      [resource]="resources[0]"
    ></dcp-product-single-resource-tile>
  </div>
  <div class="d-lg-none horizontal-scrolling">
    <div class="horizontal-scrolling__row">
      <ng-container *ngFor="let resource of resources">
        <div *ngIf="resource.value && resource.value !== ''" class="horizontal-scrolling__tile">
          <dcp-product-resource-tile [resource]="resource"></dcp-product-resource-tile>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="ds-shadow mt-6"></div>
</div>
